import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { Box } from '@mui/material'
import { theme } from 'Providers/ThemeProvider'
import { FormikHelpers, useFormik } from 'formik'
import useAuthContext from 'hooks/useAuthContext'
import useToastify from 'hooks/useToastify'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Text, TextField } from 'shared/components'
import { AdminLoginRequestModel } from 'types/admin'
import * as yup from 'yup'

const validationSchema = yup.object({
  userName: yup.string().required('Vui lòng nhập tên đăng nhập!'),
  password: yup.string().required('Vui lòng nhập mật khẩu!'),
})

const Login = () => {
  const navigate = useNavigate()
  const { showError } = useToastify()
  const [showPassword, setShowPassword] = useState(false)
  const { handleLogin, isLogin, isAuthenticated } = useAuthContext()

  const onSubmit = async (
    val: AdminLoginRequestModel,
    formikHelper: FormikHelpers<AdminLoginRequestModel>
  ) => {
    await handleLogin(val)
      .then(res => {
        if (res?.ErrorCode === 0) {
          navigate('/')
        } else if (res?.ErrorCode === 1 && !!res?.ErrorMessage) {
          formikHelper.setFieldError('password', res.ErrorMessage)
        } else {
          showError(
            'Đã xảy ra lỗi, vui lòng thử lại hoặc liên hệ với quản trị viên!'
          )
        }
      })
      .catch(e => {
        showError(
          'Đã xảy ra lỗi, vui lòng thử lại hoặc liên hệ với quản trị viên!'
        )
      })
  }

  const { handleSubmit, handleBlur, handleChange, errors, touched } =
    useFormik<AdminLoginRequestModel>({
      initialValues: {
        password: '',
        userName: '',
      },
      onSubmit,
      validationSchema,
    })

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/')
    }
  }, [navigate, isAuthenticated])

  return (
    <form>
      <Box
        p={theme.spacing(4, 4, 6)}
        borderRadius={2}
        boxShadow={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        gap={3}
        width={400}
      >
        <img width={60} height={60} alt="logo" src="/assets/img/app_logo.jpg" />
        <Text variant="h4">Đăng nhập</Text>
        <TextField
          name="userName"
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.userName && touched.userName}
          helperText={
            !!errors.userName && touched.userName ? errors.userName : ''
          }
          placeholder="Nhập tên đăng nhập"
          fullWidth
          label="Tên đăng nhập"
        />
        <TextField
          name="password"
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.password && touched.password}
          helperText={
            !!errors.password && touched.password ? errors.password : ''
          }
          type={showPassword ? 'text' : 'password'}
          fullWidth
          placeholder="Nhập mật khẩu"
          label="Mật khẩu"
          sx={{
            '& svg': {
              cursor: 'pointer',
            },
          }}
          InputProps={{
            endAdornment: showPassword ? (
              <VisibilityOffOutlinedIcon
                onClick={() => setShowPassword(false)}
              />
            ) : (
              <VisibilityOutlinedIcon onClick={() => setShowPassword(true)} />
            ),
          }}
        />
        <Button
          onClick={e => {
            e.preventDefault()
            setTimeout(() => handleSubmit(), 500)
          }}
          type="submit"
          disabled={isLogin}
          loading={isLogin}
          fullWidth
        >
          Đăng nhập
        </Button>
      </Box>
    </form>
  )
}
export default Login
